import { verifyRain, type RainOffer, type RainPrepareInput, type RainEvent } from "@crashx/shared";
import { chatApi } from "./chatApi.js";

export class RainAttempt {
  private offer: RainOffer | null = null;
  private clientSeed: string | null = null;
  readonly input: RainPrepareInput;
  constructor(amount: string, recipients: number) {
    this.input = { amount, recipients, currency: "FUN", clientRef: crypto.randomUUID() };
  }
  async run(): Promise<RainEvent> {
    this.offer ??= await chatApi.prepare(this.input);
    // Generate only after receiving the commitment; retain the same seed on uncertain retries.
    this.clientSeed ??= Array.from(crypto.getRandomValues(new Uint8Array(32)), (byte) =>
      byte.toString(16).padStart(2, "0"),
    ).join("");
    const result = await chatApi.rain({ id: this.offer.id, clientSeed: this.clientSeed });
    if (
      result.commitment !== this.offer.commitment ||
      result.id !== this.offer.id ||
      result.clientSeed !== this.clientSeed ||
      !(await verifyRain(result))
    )
      throw new Error("Rain proof mismatch");
    return result;
  }
}
